<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="10">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h5-medium-black">Compila il form per ricevere l'offerta che fa al caso tuo.<br><strong class="h5-bold-black">&Egrave; gratis e senza impegno!</strong></h3>
              <p class="h6-bold-azure-uppercase text-uppercase mt-4 mb-0">PAROLA DI SGR LUCE E GAS</p>
              <p class="h7-block-black" style="line-height: 1.55">• Garantiamo la protezione dei tuoi dati personali. <br>• Nessun costo nascosto,
                nessun impegno.<br>• La convenienza è a portata di click!</p>
            </b-col>
            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Ricevi-resoconto.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <validation-observer ref="observer">
            <b-form @submit.stop.prevent="sendForm">
              <validation-provider
                  name="Nome"
                  :rules="{ required: true, min: 3 }"
                  v-slot="validationContext"
              >
                <b-form-group
                    label="Nome *"
                    label-for="field1"
                    :state="states.firstname"
                >
                  <div class="mb-2">
                    <b-form-input id="field1" v-model="localOptions.user.firstname"
                                  :state="getValidationState(validationContext)"
                                  type="text" class="form-control form-control-gray-900"
                                  placeholder="Inserisci il tuo nome *"
                                  aria-describedby="input-1-live-feedback"></b-form-input>

                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                        validationContext.errors[0]
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </validation-provider>
              <validation-provider
                  name="Cognome"
                  :rules="{ required: true, min: 3 }"
                  v-slot="validationContext"
              >
                <b-form-group
                    label="Cognome *"
                    label-for="field2"
                    :state="states.lastname"
                >
                  <div class="mb-2">
                    <b-form-input id="field2" v-model="localOptions.user.lastname" type="text"
                                  class="form-control form-control-gray-900"
                                  :state="getValidationState(validationContext)"
                                  aria-describedby="input-2-live-feedback"
                                  placeholder="Inserisci il tuo cognome *"></b-form-input>
                    <b-form-invalid-feedback id="input-2-live-feedback">{{
                        validationContext.errors[0]
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </validation-provider>
              <validation-provider
                  name="E-mail"
                  :rules="{ required: true, min: 3, email: true }"
                  v-slot="validationContext"
              >
                <b-form-group
                    label="Email *"
                    label-for="field3"
                    :state="states.email"
                >
                  <div class="mb-2">
                    <b-form-input id="field3" v-model="localOptions.user.email" type="email"
                                  class="form-control form-control-gray-900"
                                  :state="getValidationState(validationContext)"
                                  aria-describedby="input-3-live-feedback"
                                  placeholder="Inserisci la tua email *"></b-form-input>

                    <b-form-invalid-feedback id="input-3-live-feedback">{{
                        validationContext.errors[0]
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </validation-provider>
              <b-form-group
                  label="Comune *"
                  label-for="fieldCity"
              >
                <div class="mb-2">
                  <vue-bootstrap-typeahead
                      :class="['b-autocomplete', { 'city-valid': city && search, 'city-invalid': cityError }]"
                      :data="comuni"
                      v-model="search"
                      size="lg"
                      :serializer="s => s.value"
                      placeholder="Inserisci il tuo comune *"
                      @hit="city = $event.value; cityError = false"
                  ></vue-bootstrap-typeahead>
                  <div v-if="cityError" class="invalid-feedback d-block">Il comune è obbligatorio.</div>
                </div>
              </b-form-group>
              <b-form-group
                  label="Telefono"
                  label-for="field4"
                  :state="states.phone"
              >
                <div class="input-group mb-2">
                  <b-form-input id="field4" v-model="localOptions.user.phone" type="tel"
                                class="form-control form-control-gray-900"
                                placeholder="Inserisci il tuo telefono"></b-form-input>
                </div>
              </b-form-group>
              <b-form-group class="form-check mb-0" :state="stateCheck">
                <input type="checkbox" v-model="localOptions.user.privacy" :value="true" class="form-check-input"
                       id="privacyCheck">
                <label class="form-check-label h8-regular-gray-600 ml-2" for="privacyCheck">
                  Acconsento al trattamento dei miei dati personali.
                  Consulta la <a href="https://www.sgrlucegas.com/privacy-policy/"
                                 class="h8-regular-azure-underline"
                                 target="_blank">Privacy Policy</a>.</label>
                <div v-if="privacyError" class="invalid-feedback d-block">Accettazione della privacy obbligatoria.</div>
              </b-form-group>
              <b-alert variant="danger" class="mt-3" :show="!!errorMessage">{{ errorMessage }}</b-alert>
              <div class="text-right">
                <button type="submit" class="button-azure-rounded mt-4 px-10" :disabled="loading">
                  INVIA
                </button>
              </div>
              <p class="mt-2 text-right"><small>* campi obbligatori</small></p>
            </b-form>
          </validation-observer>
        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Ricevi-resoconto.svg">
          </div>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { RECAPTCHA_ACTIONS, getRecaptchaToken } from '@/config/recaptcha';
const API_URL = 'wp-admin/admin-ajax.php?action=automplete_comune&query=:query'
export default {
  name: 'Step-7',
  components: {VueBootstrapTypeahead},
  data() {
    return {
      thisStep: 7,
      loading: true,
      result: null,
      webPath: process.env.VUE_APP_WEB_PATH,
      qOptions: null,
      localOptions: {
        user: {
          firstname: '',
          lastname: '',
          email: '',
          privacy: '',
          phone: '',
          city: '',
        }
      },
      states: {},
      search: '',
      comuni: [],
      city: null,
      cityError: false,
      privacyError: false,
      errorMessage: '',
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stateCheck: function () {
      return this.localOptions.user.privacy;
    }
  },
  watch: {
    search: function (val) {
      if (!val) this.city = null;
      this.getAddresses(val)
    }
  },
  created() {
   if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;


    if (typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-7');
    }
  },
  methods: {
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    async getAddresses(query) {
      let url = this.webPath + API_URL;
      let res = await fetch(url.replace(':query', query))
      let suggestions = await res.json()
      this.comuni = suggestions.suggestions;
    },
    /*
     * Ripristina il form quando l'invio non va a buon fine,
     * cosi' l'utente non resta bloccato sulla schermata di caricamento.
     */
    handleError(message, error) {
      if (error) console.log('error', error);
      this.errorMessage = message;
      this.loading = false;
      this.$emit('setHideSteps', false);
    },
    async sendForm() {
      this.errorMessage = '';

      // Trigger vee-validate
      const isValid = await this.$refs.observer.validate();

      // Check city
      this.cityError = !this.city;
      // Check privacy
      this.privacyError = !this.localOptions.user.privacy;

      if (!isValid || this.cityError || this.privacyError) return;

      let that = this;

      if (typeof this.$ga != 'undefined') {
        this.$ga.event('lead', 'check-up-energetico', 'richiesta-resoconto-checkup-energetico')
        if (that.localOptions.user.phone.length > 0) this.$ga.event('contatto', 'check-up-energetico', 'richiesta-resoconto-checkup-energetico');
      }

      if (typeof this.$gtag != 'undefined') {
        this.$gtag.event('lead',{ 'event_category': 'check-up-energetico', 'event_label': 'richiesta-resoconto-checkup-energetico'  });

        if (that.localOptions.user.phone.length > 0) this.$gtag.event('contatto',{ 'event_category': 'check-up-energetico', 'event_label': 'richiesta-resoconto-checkup-energetico' });
      }

      if (typeof this.$analytics != 'undefined') {
        this.trackFbLead('check-up-energetico', 'richiesta resoconto');
      }

      that.loading = true;
      that.$emit('setHideSteps', true);
      const checkupToken = await getRecaptchaToken(RECAPTCHA_ACTIONS.GET_CHECKUP);

      that.axios.post(this.webPath + 'wp-admin/admin-ajax.php?action=get_checkup', {
        ...that.localOptions,
        recaptcha_token: checkupToken,
        recaptcha_action: RECAPTCHA_ACTIONS.GET_CHECKUP,
      })
          .then(async response => {
            if (response.data && response.data.recaptcha_error) {
              return that.handleError(response.data.message);
            }

            that.result = response.data;
            that.id = that.result.id;

            if (typeof that.$analytics != 'undefined') {
              this.trackFbViewContent('check-up-energetico', 'resoconto');
            }

            const sendToken = await getRecaptchaToken(RECAPTCHA_ACTIONS.SEND_CHECKUP);

            that.axios.post(this.webPath + 'wp-admin/admin-ajax.php?action=send_checkup', {
              email: that.localOptions.user.email,
              phone: that.localOptions.user.phone,
              firstname: that.localOptions.user.firstname,
              lastname: that.localOptions.user.lastname,
              city: that.city,
              id: that.id,
              recaptcha_token: sendToken,
              recaptcha_action: RECAPTCHA_ACTIONS.SEND_CHECKUP,
            })
                .then(response => {
                  if (response.data && response.data.recaptcha_error) {
                    return that.handleError(response.data.message);
                  }

                  that.localOptions.user.email = '';
                  that.localOptions.user.phone = '';
                  that.localOptions.user.firstname = '';
                  that.localOptions.user.lastname = '';
                  that.localOptions.user.gia_cliente = '';
                  that.localOptions.user.codice_cliente = '';
                  that.$router.push({name: 'message-sent'});
                })
                .catch(error => {
                  that.handleError('Non e\' stato possibile inviare il resoconto. Riprova.', error);
                })
          })
          .catch(error => {
            that.handleError('Non e\' stato possibile elaborare la richiesta. Riprova.', error);
          });
    }
  },
}
</script>

<style scoped lang="scss">
</style>
<style lang="scss">
.vbt-autcomplete-list{
  padding: 0 !important;
  border: 1px solid #ecf1f4;
  background: #FFF;
  overflow: auto;
  border-radius: 8px;
  margin-top: 8px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  &:empty{
    border: none !important;
    display: none;
  }

  .list-group-item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    border: 0;
    span{
      color: #585F6C;
      font-size: 14px;
      line-height: 18px;
      vertical-align: middle;
      strong{
        font-size: 18px;
        color: #0090df;
      }
    }
    &.active{
      background: #ecf1f4;
      margin: 0;
      border: 0;
      span{
        color: #585F6C;
        strong{
          color: #0090df;
        }
      }
    }
  }
}
.city-valid {
  .form-control{
    border-color:#28a745;
    padding-right:calc(1.5em + .75rem)!important;
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.1875rem) center;
    background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E");
  }
  .form-control:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
  }
}
.city-invalid {
  .form-control {
    border-color: #dc3545 !important;
  }
}
.b-autocomplete{
  .form-control{
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    border: none;
    border-radius: 28px;
    height: 48px !important;
    background-color: #ecf1f4;
    color: #191c21 !important;
    padding: 16px 32px;
    text-align: left;
  }
}
</style>
